import classNames from "classnames";
import { PortalAdditionalReportViewModel } from "../../../../generated/data-contracts";
import { InteractiveBlock } from "../../../shared/components/form";

interface IReportsListReportItemProps {
  report: PortalAdditionalReportViewModel;
  isSelected: boolean;
  setSelectedReport: (
    report: PortalAdditionalReportViewModel | undefined,
  ) => void;
}

export function ReportsListReportItem(
  props: Readonly<IReportsListReportItemProps>,
) {
  const { report, isSelected, setSelectedReport } = props;
  const itemClassName = classNames(
    "report-list-report-item",
    isSelected && "row-selected",
  );

  const onItemClick = () => {
    setSelectedReport(report);

    //Scroll to element async - it has to be in dom to scrollIntoView
    setTimeout(() => {
      const selectedReportDetailsBlock = document.getElementById(
        "selectedReportDetails",
      );
      if (selectedReportDetailsBlock) {
        selectedReportDetailsBlock?.scrollIntoView({ behavior: "smooth" });
      }
    }, 200);
  };

  return (
    <InteractiveBlock onClick={onItemClick} className={itemClassName} boxShadow>
      {report.name}
    </InteractiveBlock>
  );
}
